import { render, staticRenderFns } from "./HorizontalSidebar.vue?vue&type=template&id=56e0d729&"
import script from "./HorizontalSidebar.vue?vue&type=script&lang=js&"
export * from "./HorizontalSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalSidebar.vue?vue&type=style&index=0&id=56e0d729&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports